module.exports = __webpack_public_path__ + "static/media/avatar_10.aee94261.svg";